<template>
  <div>
    <NieuwsBrief />
    <footer class="ws-footer">
      <div class="footer-inner">
        <div class="footer-grid">
          <div class="footer-brand">
            <v-img
              class="footer-logo"
              src="@/assets/logo-landscape.svg"
              alt="WeShare4Kids"
              :eager="true"
            ></v-img>
            <p class="footer-desc">
              Stichting WeShare4Kids richt zich op kinderen met een ernstige
              ziekte en op het weer bij elkaar brengen van het gezin in een
              ontspannen sfeer.
            </p>
            <div class="footer-org">
              RSIN: 866405239<br />
              Kamer van Koophandel: 93448953<br />
              IBAN: NL59 RABO 0387 9982 17
            </div>
            <v-img
              src="@/assets/anbi.svg"
              class="footer-anbi"
              alt="ANBI keurmerk: Algemeen Nut Beogende Instelling"
              width="92"
            ></v-img>
          </div>

          <div class="footer-col">
            <h4><router-link to="/overons">Over ons</router-link></h4>
            <ul>
              <li v-for="(item, i) in overOns" :key="i">
                <router-link :to="item.link">{{ item.text }}</router-link>
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h4><router-link to="/organisatie">Organisatie</router-link></h4>
            <ul>
              <li v-for="(item, i) in organisatie" :key="i">
                <router-link :to="item.link">{{ item.text }}</router-link>
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h4><router-link to="/nieuws">Nieuws</router-link></h4>
            <ul>
              <li>
                <router-link to="/nieuws"
                  >Bekijk alle nieuwsartikelen</router-link
                >
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h4><router-link to="/contact">Contact</router-link></h4>
            <ul>
              <li><router-link to="/steunons">Steun ons</router-link></li>
              <li><router-link to="/contact">Contactformulier</router-link></li>
            </ul>
          </div>
        </div>

        <div class="footer-bottom">
          © 2026 Stichting WeShare4Kids. Alle rechten voorbehouden.
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import NieuwsBrief from "@/components/NieuwsBrief.vue";
export default {
  components: {
    NieuwsBrief,
  },
  data() {
    return {
      overOns: [
        { text: "Historie", link: "/overons#historie" },
        { text: "Missie", link: "/overons#missie" },
        { text: "Visie", link: "/overons#visie" },
        { text: "Werkwijze", link: "/overons#werkwijze" },
      ],
      organisatie: [
        { text: "Team", link: "/organisatie#team" },
        { text: "ANBI verslag 2025", link: "/organisatie#anbi" },
        { text: "Partners", link: "/organisatie#partners" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.ws-footer {
  background: #fbf4ec;
  border-top: 1px solid rgba(42, 32, 24, 0.08);
}
.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 56px 32px 48px;
}
.footer-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr 1fr;
  gap: 36px;
}
.footer-logo {
  width: 165px;
  margin-bottom: 16px;
}
.footer-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #6b5d52;
  max-width: 30em;
}
.footer-org {
  font-size: 13px;
  color: #8a7c6f;
  margin-top: 16px;
  line-height: 1.7;
}
.footer-anbi {
  margin-top: 18px;
}
.footer-col {
  h4 {
    font-family: "Nunito", sans-serif;
    font-weight: 800;
    font-size: 15px;
    margin-bottom: 14px;

    a {
      color: #241b12;
    }
  }
  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
  }
  li {
    font-size: 14.5px;
  }
  a {
    color: #6b5d52;
    text-decoration: none;
    cursor: pointer;
    transition: color var(--ws-dur-fast) var(--ws-ease-out);
  }
  a:hover {
    color: #c2541a;
  }
}
.footer-bottom {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid rgba(42, 32, 24, 0.08);
  font-size: 13px;
  color: #9a8c7e;
}

@media screen and (max-width: 900px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }
  .footer-brand {
    grid-column: 1 / -1;
  }
}
@media screen and (max-width: 600px) {
  .footer-inner {
    padding: 44px 20px 36px;
  }
  .footer-grid {
    grid-template-columns: 1fr;
  }
}
</style>
